import { batch } from 'react-redux';
import { IDeviceStatusItem } from 'src/common/interfaces/states/IDeviceStatusItem';
import { store } from '../../common/redux/configure-store';
import { DeviceStatusActions } from '../../common/redux/reducers/device-status-reducer';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { IDeviceConfigurationDictionary } from '../interfaces/IDeviceConfigurationDictionary';
import { createDeviceStatusItem } from './common/create-device-status-item';

export const addDevices = (
  devices: IDeviceConfigurationDictionary[],
  showCustomerDisplay: boolean,
): void => {
  batch(() => {
    store.dispatch(DeviceStatusActions.clearDevices());
    const deviceStatuses: IDeviceStatusItem[] = [];
    devices.forEach(device => {
      try {
        deviceStatuses.push(createDeviceStatusItem(device));
      } catch (error) {
        popupMessage(error);
      }
    });

    store.dispatch(DeviceStatusActions.setDevices(deviceStatuses));
    store.dispatch(DeviceStatusActions.updateCustomerDisplay(showCustomerDisplay));
  });
};
